// authSlice.js
import { createAction, createSlice } from '@reduxjs/toolkit';
// Define the initial state for  slice
const initialState = {

  tab: "",
  user: null,
  error: null,
  status: 'idle',
  token: null,
  userId: null,
  redirectTo: null,
  userType: null,

  getAllLocationSuccess: false,
  getAllLocationFailure: false,
  getgetAllLocation: {},

  getAllKidsSuccess: false,
  getAllKidsFailure: false,
  getAllkids: {},


  getAllPlansSuccess: false,
  getAllPlansFailure: false,
  getAllPlans: {},

  createKidSuccess: false,
  createKid: {},
  createKidFailure: false,

  serviceScheduled: {},
  planChoosed: {},
  daysSelected: [],
  kidsSelected: [],
  kidsByDay: {},


  getAllAddressSuccess: false,
  getAllAddressFailure: false,
  getAllAdress: {},

  selectedAddress: [],

  saveRecurringLodaer: false,
  saveRecurringSuccess: false,
  saveRecurringFailure: false,
  saveRecurringResponse: {},

};

export const loginCreator = createAction('Login_CREATOR');
export const loginCreatorType = loginCreator().type;

export const getAllLocationCreator = createAction('getAllLocation_CREATOR');
export const getAllLocationType = getAllLocationCreator().type;

export const getAllKidsCreator = createAction('getAllKids_CREATOR');
export const getAllKidsCreatorType = getAllKidsCreator().type;


export const getAllPlansCreator = createAction('getAllPlans_CREATOR');
export const getAllPlansCreatorType = getAllPlansCreator().type;

export const createKidCreator = createAction('createKidCreator_CREATOR');
export const createKidCreatorType = createKidCreator().type;

export const resetCreateKidSuccessCreator = createAction('resetCreateKidSuccess_CREATOR');
export const resetCreateKidSuccessCreatorType = resetCreateKidSuccessCreator().type;


export const getAllAddressCreator = createAction('getAllAddress_CREATOR');
export const getAllAddressCreatorType = getAllAddressCreator().type;


export const selectedAddressCreator = createAction('selectedAddress_CREATOR');
export const selectedAddressCreatorType = selectedAddressCreator().type;


const authSlice = createSlice({
  name: 'auth', // Slice name
  initialState, // Initial state
  reducers: {
    // Reducer functions to update the state
    loginUser(state, action) {
      state.status = 'pending';
    },
    loginUserSuccess(state, action) {
      state.user = action.payload;
      state.error = null;
      state.status = 'complete';
      state.token = action?.payload?.Data.token
    },
    loginUserFailure(state, action) {
      state.user = null;
      state.error = action.payload;
      state.status = 'failed';
    },
    getAllLocation(state, action) {
      state.getAllLocationSuccess = false;
      state.getAllLocationFailure = false;
      state.getgetAllLocation = action?.payload;
    },
    getAllLocationSuccess(state, action) {
      state.getAllLocationSuccess = true;
      state.getAllLocationFailure = false;
      state.getgetAllLocation = action?.payload;
    },
    getAllLocationFailure(state, action) {
      state.getAllLocationSuccess = false;
      state.getAllLocationFailure = action?.payload;
      state.getgetAllLocation = {};
    },


    setToken(state, action) {
      state.token = action?.payload
    },

    setuserId(state, action) {
      state.userId = action?.payload
    },

    setuserType(state, action) {
      state.userType = action?.payload
    },

    getAllKids(state, action) {
      state.getAllKidsSuccess = false;
      state.getAllKidsFailure = false;
      state.getAllkids = action?.payload;
    },
    getAllKidsSuccess(state, action) {
      state.getAllKidsSuccess = true;
      state.getAllKidsFailure = false;
      state.getAllkids = action?.payload;
    },
    getAllKidsFailure(state, action) {
      state.getAllKidsSuccess = false;
      state.getAllKidsFailure = action?.payload;
      state.getAllkids = {};
    },

    getAllPlans(state, action) {
      state.getAllPlansSuccess = false;
      state.getAllPlansFailure = false;
      state.getAllPlans = action?.payload;
    },
    getAllPlansSuccess(state, action) {
      state.getAllPlansSuccess = true;
      state.getAllPlansFailure = false;
      state.getAllPlans = action?.payload;
    },
    getAllPlansFailure(state, action) {
      state.getAllPlansSuccess = false;
      state.getAllPlansFailure = action?.payload;
      state.getAllPlans = {};
    },
    createKid(state, action) {
      state.createKidSuccess = false;
      state.createKidFailure = false;
      state.createKid = action?.payload;
    },
    createKidSuccess(state, action) {
      if (action.payload === false) {
        state.createKidSuccess = false;
      } else {
        state.createKidSuccess = true;
        if (action.payload !== true) {
          state.createKid = action?.payload;
        }
      }
      state.createKidFailure = false;
    },
    createKidFailure(state, action) {
      state.createKidSuccess = false;
      state.createKidFailure = action?.payload;
      state.createKid = {};
    },
    resetCreateKidSuccessCreator(state, action) {
      state.createKidSuccess = false;
    },
    setScheduledService(state, action) {
      state.serviceScheduled = action?.payload
    },
    setplanChoosed(state, action) {
      state.planChoosed = action?.payload
    },
    setDaysSelected(state, action) {
      state.daysSelected = action?.payload
    },
    setTotalSelectedKids(state, action) {
      state.kidsSelected = action?.payload
    },
    setKidsByDay(state, action) {
      state.kidsByDay = action?.payload
    },
    setAllAddress(state, action) {
      state.getAllAddressSuccess = false;
      state.getAllAddressFailure = false;
      state.getAllAdress = action?.payload;
    },
    setAllAddressSuccess(state, action) {
      state.getAllAddressSuccess = true;
      state.getAllAddressFailure = false;
      state.getAllAdress = action?.payload;
    },
    setAllAddressFailure(state, action) {
      state.getAllAddressSuccess = false;
      state.getAllAddressFailure = true; // This should be a boolean
      state.getAllAdress = {};
    },

    resetAddress(state, action) {
      state.selectedAddress = []
    },

    selectedAddress(state, action) {
      state.selectedAddress = [...state.selectedAddress, action.payload];
    },

    saveRecurringResponse(state, action) {
      state.saveRecurringResponse = action?.payload;
    },
    saveRecurringFailure(state, action) {
      state.saveRecurringFailure = action?.payload;
    },
    saveRecurringSuccess(state, action) {
      state.saveRecurringSuccess = action?.payload;
    },
    saveRecurringLodaer(state, action) {
      state.saveRecurringLodaer = action.payload
    },

    resetBookingState(state) {
      state.selectedAddress = [];
      state.kidsSelected = [];
      state.daysSelected = [];
      state.planChoosed = {};
      state.serviceScheduled = {};
    },

    setTab(state, action) {
      state.tab = action.payload
    },

    setRedirectTo(state, action) {
      state.redirectTo = action.payload;
    },
    clearRedirectTo(state) {
      state.redirectTo = null;
    },

  },
});

export const loginActions = authSlice.actions;
export default authSlice.reducer;
